module.exports = __webpack_public_path__ + "img/27_22.85eccab7.png";